import type { Location } from 'react-router-dom';

export type RegistrationReturnTo = Pick<
  Location,
  'pathname' | 'search' | 'hash'
>;

export interface RegistrationNavigationState {
  returnTo?: RegistrationReturnTo;
}

export const getRegistrationReturnTo = (
  state: unknown,
): RegistrationReturnTo | undefined => {
  if (!state || typeof state !== 'object' || !('returnTo' in state)) return;

  const target = state.returnTo;
  if (
    !target ||
    typeof target !== 'object' ||
    !('pathname' in target) ||
    !('search' in target) ||
    !('hash' in target)
  )
    return;

  const { pathname, search, hash } = target;
  if (
    typeof pathname !== 'string' ||
    typeof search !== 'string' ||
    typeof hash !== 'string' ||
    !/^\/(?!\/)/.test(pathname) ||
    /[\\?#\s]/.test(pathname) ||
    (search !== '' && !search.startsWith('?')) ||
    (hash !== '' && !hash.startsWith('#'))
  )
    return;

  try {
    // Normalize dot segments and encoded route names before rejecting loops.
    const normalizedPath = decodeURIComponent(
      new URL(pathname, 'https://registration.invalid').pathname,
    );
    if (/^\/(benefit|register|terms|privacy)(\/|$)/i.test(normalizedPath))
      return;
  } catch {
    return;
  }

  return { pathname, search, hash };
};
